module.exports = __webpack_public_path__ + "static/media/Job_Management.0f0e4866.png";